import { API } from "@/services"

export const SIP_SERVERS_ENDPOINTS = {
  create(data={},extra={}){
    return API.Axios.callstats.v1.request({
      ...extra,
      url: `sip-servers`,
      method: 'POST',
      data,
    })
  },
  list(params={},extra={}){
    return API.Axios.callstats.v1.request({
      ...extra,
      url: `sip-servers`,
      method: 'GET',
      params,
    })
  },
  update(id='',data={},extra={}){
    return API.Axios.callstats.v1.request({
      ...extra,
      url: `sip-servers/${id}`,
      method: 'PUT',
      data,
    })
  },
  findById(id='',params={},extra={}){
    return API.Axios.callstats.v1.request({
      ...extra,
      url: `sip-servers/${id}`,
      method: 'GET',
      params,
    })
  },
  delete(id='',data={},extra={}){
    return API.Axios.callstats.v1.request({
      ...extra,
      url: `sip-servers/${id}`,
      method: 'DELETE',
      data,
    })
  },
}